import * as consultationSouscriptionFormNames from "./consultationSouscriptionsFormNames";

export const consultationSouscriptionInitialValues = {
  [consultationSouscriptionFormNames.IDENTIFIANT_SOUSCRIPTION_FORM_NAME]: "",
  [consultationSouscriptionFormNames.CODE_PACKAGE_FORM_NAME]: "",
  [consultationSouscriptionFormNames.ROLE_OPERATEUR_FORM_NAME]: "",
  [consultationSouscriptionFormNames.TYPE_PAIEMENT_FORM_NAME]: "",
  [consultationSouscriptionFormNames.TRANSACTION_AUTORISEE_FORM_NAME]: "",
  [consultationSouscriptionFormNames.STATUS_PACKAGE_FORM_NAME]: "",
  [consultationSouscriptionFormNames.VALIDITE_PACKAGE_FORM_NAME]: "",
  [consultationSouscriptionFormNames.VALIDITE_DU_FORM_NAME]: "",
  [consultationSouscriptionFormNames.VALIDITE_AU_FORM_NAME]: "",
  [consultationSouscriptionFormNames.STATUS_SOUSCRIPTION_FORM_NAME]: "",
  [consultationSouscriptionFormNames.DEBUT_DATE_SOUSCRIPTION_FORM_NAME]: "",
  [consultationSouscriptionFormNames.FIN_DATE_SOUSCRIPTION_FORM_NAME]: "",
  [consultationSouscriptionFormNames.EXERCICE_SOUSCRIPTION_FORM_NAME]: "",
  [consultationSouscriptionFormNames.PORT_SOUSCRIPTION_FORM_NAME]: "",
};
